import { render } from "./EmployeePayrollTax.vue?vue&type=template&id=455d7d0c&scoped=true"
import script from "./EmployeePayrollTax.vue?vue&type=script&lang=js"
export * from "./EmployeePayrollTax.vue?vue&type=script&lang=js"

import "./EmployeePayrollTax.vue?vue&type=style&index=0&id=455d7d0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455d7d0c"]])

export default __exports__